// extracted by mini-css-extract-plugin
module.exports = {"Container":"BackgroundVideo_Container__N7dbd","Video":"BackgroundVideo_Video__3TEiA","Content":"BackgroundVideo_Content__18_T9"};